import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ChartCard } from '../../../charts/ChartCard'
import { SegmentRowChart } from '../../../charts/SegmentRowChart'
import { SegmentRow } from '../../../charts/type'
import { getConditionSteps } from '../../../../utils/statistics/severityByCondition'
import { NotEnoughScreeningData } from '../../../charts/NotEnoughData'

type Props = {
  /** Empty when the API suppressed the chart. */
  rows: readonly SegmentRow[]
}

export const SeverityByConditionCard = ({ rows }: Props) => {
  const { t } = useTranslation()
  const steps = useMemo(() => getConditionSteps(t), [t])
  const hasData = rows.length > 0

  return (
    <ChartCard
      title={t('admin.statistics.severityByConditionTitle')}
      caption={
        hasData
          ? t('admin.statistics.severityByConditionCaption')
          : t('admin.statistics.severityByConditionCaptionEmpty')
      }
    >
      {hasData ? (
        <SegmentRowChart
          steps={steps}
          rows={rows}
          unit={t('admin.statistics.severityByConditionUnit')}
          labelColumn="wide"
          showRowTotals
        />
      ) : (
        <NotEnoughScreeningData />
      )}
    </ChartCard>
  )
}
